module.exports = __webpack_public_path__ + "static/media/cover-image-bottom.4688f018.png";